export const FEATURE_NAME = 'countries';

export const LIST = 'list';
export const FILTERS = 'filters';

export const FULL_NAME = 'fullname';
export const TOTAL = 'totalPopulation';
export const COUNTRY = 'country';
